export function EditIcon() {
return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    fill="none"
    viewBox="0 0 9 9"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.7"
      d="M4.582.75h-.165a.75.75 0 00-.75.75v.067a.75.75 0 01-.375.65l-.161.093a.75.75 0 01-.75 0l-.056-.03a.75.75 0 00-1.024.274l-.082.142a.75.75 0 00.273 1.024l.057.037a.75.75 0 01.375.645v.192a.75.75 0 01-.375.652l-.057.034a.75.75 0 00-.273 1.024l.082.142a.75.75 0 001.024.274l.056-.03a.75.75 0 01.75 0l.161.094a.75.75 0 01.375.649V7.5a.75.75 0 00.75.75h.165a.75.75 0 00.75-.75v-.067a.75.75 0 01.375-.65l.162-.093a.75.75 0 01.75 0l.056.03a.75.75 0 001.024-.274L7.78 6.3a.75.75 0 00-.274-1.024l-.056-.03a.75.75 0 01-.375-.652v-.188a.75.75 0 01.375-.652l.056-.034a.75.75 0 00.274-1.024l-.082-.142a.75.75 0 00-1.024-.274l-.056.03a.75.75 0 01-.75 0l-.162-.094a.75.75 0 01-.375-.649V1.5a.75.75 0 00-.75-.75v0z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.7"
      d="M4.5 5.625a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
    ></path>
  </svg>)
}